const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Normaliza lista de destinatarios (sin quitar @). */
export function normalizeRecipientField(str) {
  return String(str || "")
    .replace(/;/g, ",")
    .replace(/\s+/g, "")
    .trim();
}

/** Devuelve { ok, normalized, invalid[] } */
export function validateRecipientField(str, { required = true } = {}) {
  const normalized = normalizeRecipientField(str);
  const parts = normalized
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  if (required && !parts.length) {
    return { ok: false, normalized: "", invalid: [], message: "Debe indicar al menos un destinatario." };
  }

  const invalid = parts.filter((e) => !EMAIL_RE.test(e));
  if (invalid.length) {
    return {
      ok: false,
      normalized: parts.join(","),
      invalid,
      message: `Email no válido: ${invalid.join(", ")}\nDebe incluir @ (ej: nombre@dominio.es).`,
    };
  }

  return { ok: true, normalized: parts.join(","), invalid: [], message: "" };
}
